import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface SearchUser {
  name: string
  nameKana: string
  id: string
  birthday: string
  phoneNumber: string
  address: string
  mailAddress: string
  userType: SystemCode
  status: SystemCode
  lendCount: number
  reserveCount: number
  studentGrade: SystemCode
  studentClass: SystemCode
  studentNumber: string
}

export function SearchUserFromJSON(json: any): SearchUser {
  return {
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    id: exists(json, 'id') ? json.id : '',
    birthday: exists(json, 'birthday') ? dateToPlainFormat(json.birthday) : '',
    phoneNumber: exists(json, 'phone_number') ? json.phone_number : '',
    address: exists(json, 'address') ? json.address : '',
    mailAddress: exists(json, 'mail_address') ? json.mail_address : '',
    userType: exists(json, 'user_type')
      ? SystemCodeFromJSON(json.user_type)
      : defaultSystemCode(),
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    lendCount: exists(json, 'lend_count') ? json.lend_count : 0,
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : 0,
    studentGrade: exists(json, 'student_grade')
      ? SystemCodeFromJSON(json.student_grade)
      : defaultSystemCode(),
    studentClass: exists(json, 'student_class')
      ? SystemCodeFromJSON(json.student_class)
      : defaultSystemCode(),
    studentNumber: exists(json, 'student_number') ? json.student_number : ''
  }
}
